// (function(doc, win) {
//     var docEl = doc.documentElement,
//         resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
//         recalc = function() {
//             var clientWidth = docEl.clientWidth;
//             if (!clientWidth) return;
//             // if(clientWidth>=800){
//             //     docEl.style.fontSize = '30px';
//             // }else{
//             //     docEl.style.fontSize = 30 * (clientWidth / 800) + 'px';
//             // }
//             var maxSize = 24 * (375 / 375);
//             var size = 24 * (clientWidth / 375);
//             docEl.style.fontSize = (size<maxSize?size:maxSize) + 'px';
//         };
//     if (!doc.addEventListener) return;
//     win.addEventListener(resizeEvt, recalc, false);
//     doc.addEventListener('DOMContentLoaded', recalc, false);
// })(document, window);
function sizerem(doc, win) {
    var docEl = doc.documentElement
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    var recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            // if(clientWidth>=800){
            //     docEl.style.fontSize = '30px';
            // }else{
            //     docEl.style.fontSize = 30 * (clientWidth / 800) + 'px';
            // }
            var maxSize = 24 * (800 / 375);
            var size = 24 * (clientWidth / 375);
            console.log('maxSize',maxSize, 'size', size, 'clientWidth', clientWidth)
            docEl.style.fontSize = (size<maxSize?size:maxSize) + 'px';
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc(), false);
    doc.addEventListener('DOMContentLoaded', recalc(), false);
};

export {sizerem}



// WEBPACK FOOTER //
// ./src/config/rem.conf.js